
jQuery(document).ready(function($) {

	// Open a popup to subscribe to mailchimp list
	
	$('.button-mailchimp').on('click', function(e) {
		e.preventDefault();
		
		$.fancybox.open({
			href: $(this).attr('href'),
			type: 'iframe',
			width: 400,
			height: 700,
			padding: 0,
			margin: 10
		});
		
	});	
	
});
